<template>
    <b-col
        class="property-listing-card p-1 col-xxxl-4 col-xxxll-3"
        sm="6"
        md="12"
        lg="6"
    >
        <b-card
            no-body
            class="property-card pb-2"
            @click="handleInfoCardClick"
        >
            <b-row no-gutters>
                <b-col class="info-image-wrap">
                    <b-img
                        :src="infoCardImagePath"
                        width="90"
                    />
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col
                    class="info-card-wrap pl-3 pr-3 pb-2"
                    cols="12"
                >
                    <b-card-group
                        class="details-container d-block"
                    >
                        <b-row>
                            <b-col>
                                <b-card-group
                                    class="info-details pb-2"
                                >
                                    <b-card-text class="info m-0">
                                        Personalize Your Search
                                    </b-card-text>
                                </b-card-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col>
                                <div class="card-text">
                                    Create a safe, secure place to
                                    collaborate and manage your
                                    home purchase.
                                </div>
                            </b-col>
                        </b-row>
                    </b-card-group>
                </b-col>
            </b-row>
        </b-card>
    </b-col>
</template>

<script>
    import "./PropertyListingCard.scss";
    import "./PropertyListingInfoCard.scss";
    import {
        PROPERTY_SEARCH_DISABLED_OPTION
    } from '../../mixins/PropertySearchMixin.js';
    import {PROPERTY_SEARCH_ACTIONS} from "../../../helpers/variables";

    export default {
        name: "PropertyListingInfoCard",
        data() {
            return {
                infoCardImagePath: require('./property-listing-info.png'),
            };
        },
        methods: {
            handleInfoCardClick() {
                this.$bus.$emit(PROPERTY_SEARCH_DISABLED_OPTION, PROPERTY_SEARCH_ACTIONS.SAVE_SEARCH);
            }
        },
    };
</script>
